import { TPrice } from "../components";

export const mockedPricesMainOnly: TPrice[] = [{ currency: "€", price: "80" }];

export const mockedPricesWithDiscount: TPrice[] = [
  { currency: "€", price: "20.00" },
  { currency: "€", price: "50.00", variant: "original" },
];

export const mockedPricesWithCustomCurrencyPos: TPrice[] = [
  { currency: "kr", price: "80.00", currencyPlace: "back" },
];

export const mockedPricesWithAdditionalPrice: TPrice[] = [
  { currency: "€", price: "130.00" },
  {
    currency: "€",
    price: "149.50",
    contentBefore: "UVP* ",
    variant: "content",
  },
];

export const mockedPricesWithSeveralAdditionalPrices: TPrice[] = [
  { currency: "€", price: "135.00" },
  {
    currency: "€",
    price: "149.50",
    contentBefore: "UP* ",
    variant: "content",
  },
  {
    currency: "€",
    price: "149.50",
    contentBefore: "TP** ",
    variant: "content",
  },
  {
    currency: "€",
    price: "149.50",
    contentBefore: "CP* ",
    variant: "content",
  },
  {
    currency: "€",
    price: "149.50",
    contentBefore: "UP* ",
    variant: "content",
  },
  {
    currency: "€",
    price: "149.50",
    contentBefore: "TP** ",
    variant: "content",
  },
];
